import type { PartDefinition } from "@rogue/rackbuilder"
import { AdjustOnlyVisual } from "../../../constants"
import { getRackModel } from "../../../modelPaths"
import { WallmountBuilder } from "../wallmountBuilder"

export class RML90Slim extends WallmountBuilder {
  // Override: Different stick with brackets instead of folding crossmembers
  protected createStick(left: boolean): PartDefinition {
    const bracket = this.createBracket(left)
    
    const stick: PartDefinition = {
      mesh           : getRackModel('WM_RML_PARTS', 'RML stick numbered'),
      materials      : this.material,
      slots          : {},
      offset         : { x: 0.4 },
      adjustments    : left ? [] : [{ type: 'rotate', axis: 'Y', amount: 180 }],
      adjustmentType : AdjustOnlyVisual,
    }

    // Add sticker to left side only
    if (left) {
      stick.slots['sticker-left'] = this.createBrandingSticker(true)
    }

    // Use brackets instead of folding crossmembers
    stick.slots['top-folding-crossmember'] = bracket
    stick.slots['crossmember-bottom'] = bracket
    stick.slots['jcup-high'] = this.createJCup(left)

    return stick
  }
  
  // New method: Create bracket for 90 Slim
  protected createBracket(left: boolean): PartDefinition {
    const bracket: PartDefinition = {
      mesh        : getRackModel('WM_90_SLIM', this.config.isBracketFor90Slim ? 'bracket' : 'crossmember mount'),
      slots       : {},
      anchor      : 'top',
      offset      : this.config.isBracketFor90Slim ? {} : { z: -0.4 },
      adjustments : left ? [] : [
        { type: 'rotate', axis: 'Z', amount: 180 }, 
        { type: 'flip', axis: 'Y' },
      ],
    }

    // Add stringers if needed
    if (this.stringer) {
      bracket.slots.left = this.createStringer(left)
    }

    return bracket
  }

  // Override to conditionally attach
  protected attachPullupBar(leftSide: PartDefinition): void {
    if (!this.config.isPullupFor90Slim) {
      return
    }

    const slimPullupBar: PartDefinition = {
      mesh   : getRackModel('WM_90_SLIM', 'skinny'),
      slots  : {},
      anchor : 'top',
      offset : { x: 0.2, y: -0.1 },
    }

    leftSide.slots.top = slimPullupBar
  }
 

  // Override: Different pullup offset
  protected getPullupOffset() {
    return { x: 0.2, y: -0.1 }
  }
}